// Should stay in sync with currentAppraiserRole.mjs

export const CURRENT_APPRAISER_ROLE = {
  I_ATM_CANDIDATE: 0,
  I_ATM_APPRENTICE: 1,
  I_ATM: 2,
  ATM_CANDIDATE: 3,
  ATM_APPRENTICE: 4,
  ATM: 5,
  ATL_CANDIDATE: 6,
  ATL: 7,
  ATL_APPRENTICE: 8
};
